module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // identity function for calling harmony imports with the correct context

  /******/

  __webpack_require__.i = function (value) {
    return value;
  };
  /******/

  /******/
  // define getter function for harmony exports

  /******/


  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        /******/
        configurable: false,

        /******/
        enumerable: true,

        /******/
        get: getter
        /******/

      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 5);
  /******/
}(
/************************************************************************/

/******/
[
/* 0 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var GET_USER_DETAILS_REQUEST = exports.GET_USER_DETAILS_REQUEST = 'GET_USER_DETAILS_REQUEST';
  var GET_USER_DETAILS_SUCCESS = exports.GET_USER_DETAILS_SUCCESS = 'GET_USER_DETAILS_SUCCESS';
  var GET_USER_DETAILS_FAILURE = exports.GET_USER_DETAILS_FAILURE = 'GET_USER_DETAILS_FAILURE';
  var RESET_USER_DETAILS = exports.RESET_USER_DETAILS = 'RESET_USER_DETAILS';
  var SET_USER_DETAILS_REQUEST = exports.SET_USER_DETAILS_REQUEST = 'SET_USER_DETAILS_REQUEST';
  var SET_USER_DETAILS_SUCCESS = exports.SET_USER_DETAILS_SUCCESS = 'SET_USER_DETAILS_SUCCESS';
  var SET_USER_DETAILS_FAILURE = exports.SET_USER_DETAILS_FAILURE = 'SET_USER_DETAILS_FAILURE';
  var GET_CONTACT_OPTIONS_REQUEST = exports.GET_CONTACT_OPTIONS_REQUEST = 'GET_CONTACT_OPTIONS_REQUEST';
  var GET_CONTACT_OPTIONS_SUCCESS = exports.GET_CONTACT_OPTIONS_SUCCESS = 'GET_CONTACT_OPTIONS_SUCCESS';
  var GET_CONTACT_OPTIONS_FAILURE = exports.GET_CONTACT_OPTIONS_FAILURE = 'GET_CONTACT_OPTIONS_FAILURE';
  var RESET_CONTACT_OPTIONS = exports.RESET_CONTACT_OPTIONS = 'RESET_CONTACT_OPTIONS';
  var SET_CONTACT_OPTIONS_REQUEST = exports.SET_CONTACT_OPTIONS_REQUEST = 'SET_CONTACT_OPTIONS_REQUEST';
  var SET_CONTACT_OPTIONS_SUCCESS = exports.SET_CONTACT_OPTIONS_SUCCESS = 'SET_CONTACT_OPTIONS_SUCCESS';
  var SET_CONTACT_OPTIONS_FAILURE = exports.SET_CONTACT_OPTIONS_FAILURE = 'SET_CONTACT_OPTIONS_FAILURE';
  var SET_UPDATE_USER_DETAIL_SUCCESS = exports.SET_UPDATE_USER_DETAIL_SUCCESS = 'SET_UPDATE_USER_DETAIL_SUCCESS';
  var SET_UPDATE_USER_DETAIL_FAILURE = exports.SET_UPDATE_USER_DETAIL_FAILURE = 'SET_UPDATE_USER_DETAIL_FAILURE';
  var GET_PREFERENCES_REQUEST = exports.GET_PREFERENCES_REQUEST = 'GET_PREFERENCES_REQUEST';
  var GET_PREFERENCES_SUCCESS = exports.GET_PREFERENCES_SUCCESS = 'GET_PREFERENCES_SUCCESS';
  var GET_PREFERENCES_FAILURE = exports.GET_PREFERENCES_FAILURE = 'GET_PREFERENCES_FAILURE';
  var RESET_PREFERENCES = exports.RESET_PREFERENCES = 'RESET_PREFERENCES';
  var SET_PREFERENCES_REQUEST = exports.SET_PREFERENCES_REQUEST = 'SET_PREFERENCES_REQUEST';
  var SET_PREFERENCES_SUCCESS = exports.SET_PREFERENCES_SUCCESS = 'SET_PREFERENCES_SUCCESS';
  var SET_PREFERENCES_FAILURE = exports.SET_PREFERENCES_FAILURE = 'SET_PREFERENCES_FAILURE';
  var RESET_SET_PREFERENCES = exports.RESET_SET_PREFERENCES = 'RESET_SET_PREFERENCES';
  /***/
},
/* 1 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _actions = __webpack_require__(4);

  var actions = _interopRequireWildcard(_actions);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  var mapDispatchToProps = _extends({}, actions);

  exports.default = mapDispatchToProps;
  /***/
},
/* 2 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var mapStateToProps = function mapStateToProps(state) {
    var _state$userManagement = state.userManagementDefinition,
        userManagementDefinition = _state$userManagement === undefined ? {} : _state$userManagement;
    var userDetails = userManagementDefinition.userDetails,
        setUserDetails = userManagementDefinition.setUserDetails,
        setUserDetailSuccess = userManagementDefinition.setUserDetailSuccess,
        setPreferencesSuccess = userManagementDefinition.setPreferencesSuccess,
        contactOptions = userManagementDefinition.contactOptions,
        updateUserDetailSuccess = userManagementDefinition.updateUserDetailSuccess,
        isFetching = userManagementDefinition.isFetching,
        preferencesData = userManagementDefinition.preferencesData,
        _userManagementDefini = userManagementDefinition.error,
        error = _userManagementDefini === undefined ? null : _userManagementDefini;
    return {
      userDetails: userDetails,
      setUserDetails: setUserDetails,
      setUserDetailSuccess: setUserDetailSuccess,
      setPreferencesSuccess: setPreferencesSuccess,
      contactOptions: contactOptions,
      updateUserDetailSuccess: updateUserDetailSuccess,
      isFetching: isFetching,
      preferencesData: preferencesData,
      error: error
    };
  };

  exports.default = mapStateToProps;
  /***/
},
/* 3 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _types = __webpack_require__(0);

  var userManagementDefinition = function userManagementDefinition() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case _types.SET_PREFERENCES_SUCCESS:
        return _extends({}, state, {
          setPreferencesSuccess: action.setPreferencesSuccess,
          success: action.success,
          isFetching: action.isFetching,
          error: action.error
        });

      case _types.SET_PREFERENCES_FAILURE:
      case _types.SET_PREFERENCES_REQUEST:
        return _extends({}, state, {
          isFetching: action.isFetching,
          error: action.error
        });

      case _types.GET_PREFERENCES_SUCCESS:
        return _extends({}, state, {
          preferencesData: action.PreferencesSuccess,
          isFetching: action.isFetching,
          error: action.error
        });

      case _types.GET_PREFERENCES_FAILURE:
      case _types.GET_PREFERENCES_REQUEST:
      case _types.RESET_PREFERENCES:
        return _extends({}, state, {
          success: action.success,
          isFetching: action.isFetching,
          preferencesData: action.resetPreferences,
          setPreferencesSuccess: action.resetSetPreferences,
          error: action.error
        });

      case _types.RESET_SET_PREFERENCES:
        return _extends({}, state, {
          success: action.success,
          isFetching: action.isFetching,
          setPreferencesSuccess: action.resetSetPreferences,
          error: action.error
        });

      case _types.GET_USER_DETAILS_SUCCESS:
        return _extends({}, state, {
          userDetails: action.userDetails,
          isFetching: action.isFetching,
          error: action.error
        });

      case _types.GET_USER_DETAILS_FAILURE:
      case _types.GET_USER_DETAILS_REQUEST:
      case _types.RESET_USER_DETAILS:
        return _extends({}, state, {
          success: action.success,
          isFetching: action.isFetching,
          userDetails: action.userDetails,
          setUserDetailSuccess: action.setUserDetailSuccess,
          error: action.error
        });

      case _types.SET_USER_DETAILS_SUCCESS:
        return _extends({}, state, {
          setUserDetailSuccess: action.setUserDetailSuccess,
          success: action.success,
          isFetching: action.isFetching,
          error: action.error
        });

      case _types.SET_USER_DETAILS_FAILURE:
      case _types.SET_USER_DETAILS_REQUEST:
        return _extends({}, state, {
          isFetching: action.isFetching,
          error: action.error
        });

      case _types.GET_CONTACT_OPTIONS_SUCCESS:
        return _extends({}, state, {
          contactOptions: action.contactOptions,
          isFetching: action.isFetching,
          error: action.error
        });

      case _types.GET_CONTACT_OPTIONS_FAILURE:
      case _types.GET_CONTACT_OPTIONS_REQUEST:
      case _types.RESET_CONTACT_OPTIONS:
        return _extends({}, state, {
          success: action.success,
          isFetching: action.isFetching,
          contactOptions: action.contactOptions,
          updateUserDetailSuccess: action.updateUserDetailSuccess,
          error: action.error
        });

      case _types.SET_UPDATE_USER_DETAIL_SUCCESS:
        return _extends({}, state, {
          updateUserDetailSuccess: action.updateUserDetailSuccess,
          success: action.success,
          isFetching: action.isFetching,
          error: action.error
        });

      case _types.SET_UPDATE_USER_DETAIL_FAILURE:
      case _types.SET_CONTACT_OPTIONS_REQUEST:
        return _extends({}, state, {
          isFetching: action.isFetching,
          error: action.error
        });

      default:
        return state;
    }
  };

  exports.default = userManagementDefinition;
  /***/
},
/* 4 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.setPreferences = exports.setRreferencesFailure = exports.setRreferencesSuccess = exports.setRreferencesRequest = exports.getPreferences = exports.resetSetPreferences = exports.resetPreferences = exports.getPreferencesFailure = exports.getPreferencesSuccess = exports.getPreferencesRequest = exports.setContactOptions = exports.setUpdateUserDetailFailure = exports.setUpdateUserDetailSuccess = exports.setContactOptionsRequest = exports.fetchContactOptionsIfNeeded = exports.shouldFetchContactOptions = exports.getContactOptions = exports.resetContactOptions = exports.getContactOptionsFailure = exports.getContactOptionsSuccess = exports.getContactOptionsRequest = exports.updateUserDetails = exports.setUserDetailsFailure = exports.setUserDetailsSuccess = exports.setUserDetailsRequest = exports.fetchUserDetailsIfNeeded = exports.shouldFetchUserDetails = exports.getUserDetails = exports.resetUserDetails = exports.getUserDetailsFailure = exports.getUserDetailsSuccess = exports.getUserDetailsRequest = undefined;

  var _interact = __webpack_require__(6);

  var _types = __webpack_require__(0);

  var getUserDetailsRequest = exports.getUserDetailsRequest = function getUserDetailsRequest() {
    return {
      type: _types.GET_USER_DETAILS_REQUEST,
      isFetching: true,
      error: null
    };
  };

  var getUserDetailsSuccess = exports.getUserDetailsSuccess = function getUserDetailsSuccess(json) {
    return {
      type: _types.GET_USER_DETAILS_SUCCESS,
      userDetails: json,
      isFetching: false,
      error: null
    };
  };

  var getUserDetailsFailure = exports.getUserDetailsFailure = function getUserDetailsFailure(error) {
    return {
      type: _types.GET_USER_DETAILS_FAILURE,
      isFetching: false,
      error: error.message
    };
  };

  var resetUserDetails = exports.resetUserDetails = function resetUserDetails() {
    return {
      type: _types.RESET_USER_DETAILS,
      setUserDetailSuccess: null,
      isFetching: false,
      success: false,
      error: null,
      userDetails: null
    };
  };

  var getUserDetails = exports.getUserDetails = function getUserDetails(request) {
    return function (dispatch) {
      dispatch(getUserDetailsRequest());
      return fetch(_interact.Connection.baseUrl('usermanagement') + 'v1.0/getuserdetails', {
        method: 'post',
        headers: _interact.Connection.headers(),
        body: JSON.stringify(request)
      }).then(function (response) {
        return _interact.Connection.errored(response);
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        return dispatch(getUserDetailsSuccess(json));
      }).catch(function (error) {
        return dispatch(getUserDetailsFailure(error));
      });
    };
  };

  var shouldFetchUserDetails = exports.shouldFetchUserDetails = function shouldFetchUserDetails(state) {
    if (!state.userDetails || !state.userDetails.ExpiryDate) {
      return true;
    }

    var expiry = state.userDetails.ExpiryDate;
    return new Date() > new Date(expiry);
  };

  var fetchUserDetailsIfNeeded = exports.fetchUserDetailsIfNeeded = function fetchUserDetailsIfNeeded(request) {
    return function (dispatch, getState) {
      if (shouldFetchUserDetails(getState().userManagementDefinition)) {
        return dispatch(getUserDetails(request));
      }
    };
  };

  var setUserDetailsRequest = exports.setUserDetailsRequest = function setUserDetailsRequest() {
    return {
      type: _types.SET_USER_DETAILS_REQUEST,
      isFetching: true,
      success: false,
      error: null
    };
  };

  var setUserDetailsSuccess = exports.setUserDetailsSuccess = function setUserDetailsSuccess(json) {
    return {
      type: _types.SET_USER_DETAILS_SUCCESS,
      isFetching: false,
      setUserDetailSuccess: json,
      success: true,
      error: null
    };
  };

  var setUserDetailsFailure = exports.setUserDetailsFailure = function setUserDetailsFailure(error) {
    return {
      type: _types.SET_USER_DETAILS_FAILURE,
      isFetching: false,
      success: false,
      error: error.message
    };
  };

  var updateUserDetails = exports.updateUserDetails = function updateUserDetails(request1, request2) {
    return function (dispatch) {
      return _interact.TwoFactor.run(function () {
        dispatch(setUserDetailsRequest());
        return fetch(_interact.Connection.baseUrl('usermanagement') + 'v1.0/setuserdetails', {
          method: 'post',
          headers: _interact.Connection.headers(),
          body: JSON.stringify(request1)
        }).then(function (response) {
          return _interact.Connection.errored(response);
        }).then(function (response) {
          return response.json();
        }).then(function (json) {
          dispatch(setUserDetailsSuccess(json));

          if (json.ResponseStatus === 'Success') {
            dispatch(setContactOptions(request2));
          } else {
            dispatch(setUpdateUserDetailSuccess(json));
          }
        }).catch(function (error) {
          return dispatch(setUserDetailsFailure(error));
        });
      });
    };
  };

  var getContactOptionsRequest = exports.getContactOptionsRequest = function getContactOptionsRequest() {
    return {
      type: _types.GET_CONTACT_OPTIONS_REQUEST,
      isFetching: true,
      error: null
    };
  };

  var getContactOptionsSuccess = exports.getContactOptionsSuccess = function getContactOptionsSuccess(json) {
    return {
      type: _types.GET_CONTACT_OPTIONS_SUCCESS,
      contactOptions: json,
      isFetching: false,
      error: null
    };
  };

  var getContactOptionsFailure = exports.getContactOptionsFailure = function getContactOptionsFailure(error) {
    return {
      type: _types.GET_CONTACT_OPTIONS_FAILURE,
      isFetching: false,
      error: error.message
    };
  };

  var resetContactOptions = exports.resetContactOptions = function resetContactOptions() {
    return {
      type: _types.RESET_CONTACT_OPTIONS,
      updateUserDetailSuccess: null,
      isFetching: false,
      success: false,
      error: null,
      alerts: null
    };
  };

  var getContactOptions = exports.getContactOptions = function getContactOptions(request) {
    return function (dispatch) {
      dispatch(getContactOptionsRequest());
      return fetch(_interact.Connection.baseUrl('usermanagement') + 'v1.0/getcontactoptions', {
        method: 'post',
        headers: _interact.Connection.headers(),
        body: JSON.stringify(request)
      }).then(function (response) {
        return _interact.Connection.errored(response);
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        return dispatch(getContactOptionsSuccess(json));
      }).catch(function (error) {
        return dispatch(getContactOptionsFailure(error));
      });
    };
  };

  var shouldFetchContactOptions = exports.shouldFetchContactOptions = function shouldFetchContactOptions(state) {
    if (!state.contactOptions || !state.contactOptions.ExpiryDate) {
      return true;
    }

    var expiry = state.contactOptions.ExpiryDate;
    return new Date() > new Date(expiry);
  };

  var fetchContactOptionsIfNeeded = exports.fetchContactOptionsIfNeeded = function fetchContactOptionsIfNeeded(request) {
    return function (dispatch, getState) {
      if (shouldFetchContactOptions(getState().userManagementDefinition)) {
        return dispatch(getContactOptions(request));
      }
    };
  };

  var setContactOptionsRequest = exports.setContactOptionsRequest = function setContactOptionsRequest() {
    return {
      type: _types.SET_CONTACT_OPTIONS_REQUEST,
      isFetching: true,
      success: false,
      error: null
    };
  };

  var setUpdateUserDetailSuccess = exports.setUpdateUserDetailSuccess = function setUpdateUserDetailSuccess(json) {
    return {
      type: _types.SET_UPDATE_USER_DETAIL_SUCCESS,
      isFetching: false,
      updateUserDetailSuccess: json,
      success: true,
      error: null
    };
  };

  var setUpdateUserDetailFailure = exports.setUpdateUserDetailFailure = function setUpdateUserDetailFailure(error) {
    return {
      type: _types.SET_UPDATE_USER_DETAIL_FAILURE,
      isFetching: false,
      success: false,
      error: error.message
    };
  };

  var setContactOptions = exports.setContactOptions = function setContactOptions(request) {
    return function (dispatch) {
      return _interact.TwoFactor.run(function () {
        dispatch(setContactOptionsRequest());
        return fetch(_interact.Connection.baseUrl('usermanagement') + 'v1.0/setcontactoptions', {
          method: 'post',
          headers: _interact.Connection.headers(),
          body: JSON.stringify(request)
        }).then(function (response) {
          return _interact.Connection.errored(response);
        }).then(function (response) {
          return response.json();
        }).then(function (json) {
          return dispatch(setUpdateUserDetailSuccess(json));
        }).catch(function (error) {
          return dispatch(setUpdateUserDetailFailure(error));
        });
      });
    };
  };

  var getPreferencesRequest = exports.getPreferencesRequest = function getPreferencesRequest() {
    return {
      type: _types.GET_PREFERENCES_REQUEST,
      isFetching: true,
      success: false,
      error: null
    };
  };

  var getPreferencesSuccess = exports.getPreferencesSuccess = function getPreferencesSuccess(json) {
    return {
      type: _types.GET_PREFERENCES_SUCCESS,
      isFetching: false,
      PreferencesSuccess: json,
      success: true,
      error: null
    };
  };

  var getPreferencesFailure = exports.getPreferencesFailure = function getPreferencesFailure(error) {
    return {
      type: _types.GET_PREFERENCES_FAILURE,
      isFetching: false,
      success: false,
      error: error.message
    };
  };

  var resetPreferences = exports.resetPreferences = function resetPreferences() {
    return {
      type: _types.RESET_PREFERENCES,
      resetPreferences: null,
      resetSetPreferences: null,
      isFetching: false,
      success: false,
      error: null
    };
  };

  var resetSetPreferences = exports.resetSetPreferences = function resetSetPreferences() {
    return {
      type: _types.RESET_SET_PREFERENCES,
      resetSetPreferences: null,
      isFetching: false,
      success: false,
      error: null
    };
  };

  var getPreferences = exports.getPreferences = function getPreferences(request) {
    return function (dispatch) {
      dispatch(getPreferencesRequest());
      return fetch(_interact.Connection.baseUrl('usermanagement') + 'v1.0/getpreferences', {
        method: 'post',
        headers: _interact.Connection.headers(),
        body: JSON.stringify(request)
      }).then(function (response) {
        return _interact.Connection.errored(response);
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        return dispatch(getPreferencesSuccess(json));
      }).catch(function (error) {
        return dispatch(getPreferencesFailure(error));
      });
    };
  };

  var setRreferencesRequest = exports.setRreferencesRequest = function setRreferencesRequest() {
    return {
      type: _types.SET_PREFERENCES_REQUEST,
      isFetching: true,
      success: false,
      error: null
    };
  };

  var setRreferencesSuccess = exports.setRreferencesSuccess = function setRreferencesSuccess(json) {
    return {
      type: _types.SET_PREFERENCES_SUCCESS,
      isFetching: false,
      setPreferencesSuccess: json,
      success: true,
      error: null
    };
  };

  var setRreferencesFailure = exports.setRreferencesFailure = function setRreferencesFailure(error) {
    return {
      type: _types.SET_PREFERENCES_FAILURE,
      isFetching: false,
      success: false,
      error: error.message
    };
  };

  var setPreferences = exports.setPreferences = function setPreferences(request) {
    return function (dispatch) {
      return _interact.TwoFactor.run(function () {
        dispatch(setRreferencesRequest());
        return fetch(_interact.Connection.baseUrl('usermanagement') + 'v1.0/setpreferences', {
          method: 'post',
          headers: _interact.Connection.headers(),
          body: JSON.stringify(request)
        }).then(function (response) {
          return _interact.Connection.errored(response);
        }).then(function (response) {
          return response.json();
        }).then(function (json) {
          return dispatch(setRreferencesSuccess(json));
        }).catch(function (error) {
          return dispatch(setRreferencesFailure(error));
        });
      });
    };
  };
  /***/

},
/* 5 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.mapDispatchToProps = exports.mapStateToProps = exports.userManagementDefinition = undefined;

  var _reducer = __webpack_require__(3);

  var _reducer2 = _interopRequireDefault(_reducer);

  var _mapStateToProps = __webpack_require__(2);

  var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);

  var _mapDispatchToProps = __webpack_require__(1);

  var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.userManagementDefinition = _reducer2.default;
  exports.mapStateToProps = _mapStateToProps2.default;
  exports.mapDispatchToProps = _mapDispatchToProps2.default;
  /***/
},
/* 6 */

/***/
function (module, exports) {
  module.exports = require("@myie/interact");
  /***/
}
/******/
]);